<template>
  <div class="modal-SOSSet">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">添加SOS联系人</div>
        <button type="button" class="btn-close" @click="closeSelf">关闭</button>
      </div>

      <div class="modal-body">
        <template>
          <el-row style="margin-bottom: 25px;" >
            <el-col :span="12" class="item" >
              <span>姓名:</span>
              <el-input placeholder="请输入姓名" v-model="contacts.name" maxlength="11" clearable
                        style="width:100%;margin-top:5px"></el-input>
            </el-col>

            <el-col :span="12" class="item">
              <span>手机号:</span>
              <el-input placeholder="请输入手机"  v-model="contacts.phone" maxlength="11" clearable
                        style="width:100%;margin-top:5px"></el-input>
            </el-col>
          </el-row>

          


        </template>
      </div>
      <div class="modal-footer">
            <el-button :loading="loading" type="primary" @click="AddSOSContacts">添加</el-button>
          </div>
    </div>





  </div>
</template>

<script>




export default {
  name: "AddContacts",
  data() {
    return {
      addContactsShow:false,
      userCode: '',
      tableData:'',
      contacts:{
        name:'',
        phone:'',
      }



    }
  },
  components: {

  },

  methods: {
    init(row, userCode) {
      this.userCode = userCode;
      this.contacts.name='';
      this.contacts.phone='';
    },
    closeSelf() {
      this.$emit("closeAddContacts");
    },
    closeAddContacts(){
      this.addContactsShow =!this.addContactsShow;
    },
    AddSOSContacts(){
      if(this.name===''){
        this.$message({type: 'warning', message: '请填写姓名!'});
      }else if(this.phone===''){
        this.$message({type: 'warning', message: '请填写手机号码!'});
      }
      var   a =JSON.parse(JSON.stringify(this.contacts))
      this.$emit("getData",a);
      this.$emit("closeAddContacts");
    },



  }


}
</script>

<style lang="scss" scoped>

.modal-SOSSet {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .modal {
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width: 600px;


    .modal-header {
      border-bottom: 1px solid #eee;
      color: #313131;
      justify-content: space-between;
      padding: 10px;
      display: flex;
    }

    .modal-body {
      position: relative;
      padding: 20px 0;
      z-index: 99;
      height: 100%;
    }
    .modal-footer{
      border-top: 1px solid #eee;
      justify-content: flex-end;
      padding: 15px;
      display: flex;
    }



  }

}


.btn-close, .btn-confirm {
  border-radius: 8px;
  margin-left: 16px;
  width: 56px;
  height: 36px;
  border: none;
  cursor: pointer;
}

.btn-close {
  color: #313131;
  background-color: transparent;
}


.row {
  padding: 10px 0px;
}

.item {
  padding: 0px 20px;
}

.label {
  padding: 5px 0px;
}

</style>